import { useState, useEffect } from 'react';

const SCROLL_THRESHOLD = 400;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      className="fixed bottom-4 left-4 z-40 h-10 w-10 sm:bottom-6 sm:left-6 sm:h-12 sm:w-12 rounded-full bg-[#1769ff] text-white shadow-lg shadow-[#1769ff]/30 hover:bg-[#0f55d4] hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 flex items-center justify-center cursor-pointer"
    >
      <i className="ri-arrow-up-s-line text-2xl"></i>
    </button>
  );
}
